if (!customElements.get('bonus-points-latori')) {
  class BonusPointsLatori extends HTMLElement {
    connectedCallback() {
      this.amountEl = this.querySelector('.order-placed-potential-points-amount');
      this.quantityInput = this.closest('.product-form')?.querySelector('[name="quantity"]') || null;

      this.handleQuantityChange = (typeof debounce === 'function' ? debounce(this.recalculate.bind(this), 150) : this.recalculate.bind(this));

      if (this.quantityInput) {
        this.quantityInput.addEventListener('input', this.handleQuantityChange);
        this.quantityInput.addEventListener('change', this.handleQuantityChange);
      }

      this.recalculate();

      // Once Rivo's program config is on the page, recalculate with the live
      // rate/rounding instead of the Liquid-rendered fallback constants.
      if (window.rivoConfigLatori) {
        window.rivoConfigLatori.ready(() => {
          if (this.isConnected) this.recalculate();
        });
      }
    }

    disconnectedCallback() {
      if (this.quantityInput) {
        this.quantityInput.removeEventListener('input', this.handleQuantityChange);
        this.quantityInput.removeEventListener('change', this.handleQuantityChange);
      }
    }

    getQuantity() {
      const value = parseInt(this.quantityInput?.value, 10);
      return Number.isNaN(value) || value < 1 ? 1 : value;
    }

    recalculate() {
      if (!this.amountEl) return;

      const priceCents = parseInt(this.dataset.price, 10) || 0;
      const quantity = this.getQuantity();
      const totalCents = priceCents * quantity;

      // Preferred: Rivo's own config (window.Rivo.loy_config) via
      // rivo-config-latori.js - tier rate and the shop's rounding rule.
      const live = window.rivoConfigLatori ? window.rivoConfigLatori.points(totalCents, this.dataset.vipTier) : null;
      if (live !== null && live !== undefined) {
        this.amountEl.textContent = window.rivoConfigLatori.formatPoints(live);
        return;
      }

      // Fallback while Rivo hasn't loaded: the data attributes rendered by
      // snippets/bonus-points-latori.liquid. Rivo floors once, after applying
      // the tier rate to the order total (44.75 EUR x 5 = 223.75 → 223).
      const balanceAmount = parseFloat(this.dataset.balanceAmount) || 0;
      const currencyBaseAmount = parseFloat(this.dataset.currencyBaseAmount) || 1;
      const totalSpend = totalCents / 100;
      const points = Math.floor((totalSpend * balanceAmount) / currencyBaseAmount);
      this.amountEl.textContent = String(points).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }

  customElements.define('bonus-points-latori', BonusPointsLatori);
}
